import { render, staticRenderFns } from "./UserId.vue?vue&type=template&id=88d9509a&scoped=true&"
import script from "./UserId.vue?vue&type=script&lang=js&"
export * from "./UserId.vue?vue&type=script&lang=js&"
import style0 from "./UserId.vue?vue&type=style&index=0&id=88d9509a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d9509a",
  null
  
)

export default component.exports